import { defineMessages } from 'react-intl';

import { Checkbox } from '#src/atoms/inputs/Checkbox/index.tsx';
import { useIntlContext } from '#src/contexts/intl/index.ts';

const messages = defineMessages({
  partnersLabel: {
    defaultMessage:
      'I agree to share my information with Sorare’s trusted partners for marketing and promotional purposes',
  },
});

export const AgreeToReceiveOffersFromPartners = (props: {
  checked: boolean;
  onChange: () => void;
  name: string;
}) => {
  const { formatMessage } = useIntlContext();

  return <Checkbox {...props} label={formatMessage(messages.partnersLabel)} />;
};
